var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-container"},_vm._l((_vm.arr),function(url){return _c('iframe',{key:url,attrs:{"src":_vm.generatePdfUrl(url),"frameborder":"0"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }